












































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { Spinner } from 'vue-image-spinner2';
import moment from 'moment-timezone';
import { Debounce } from 'vue-debounce-decorator';
import _, { flatten } from 'lodash';
import { directusApi } from '@/api';
import QuotationPreview from '../components/QuotationPreview.vue';
import * as XLSX from 'xlsx';
import products from '@/store/products';

@Component({
    name: 'quotations',
    data: function () {
        return {
            productsPageTest: 1,
        };
    },
    components: {
        QuotationPreview,
        Spinner,
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('products', [
            'activeQuotationLoading',
            'activeQuotation',
            'allProducts',
            'allProductsLoading',
            'cacheProducts',
            'productsPerPage',
            'productsPage',
            'productsTotal',
            'cacheProductsLoading',
            'cacheClients',
            'users_intelisis',
            'message',
        ]),
        ...mapFields({
            activeQuotation: 'products.activeQuotation',
            client: 'products.client',
        }),
    },
    methods: {
        setColspan() {
            if (window.innerWidth < 768) {
                return 3;
            } else {
                return 6;
            }
        },
    },
})
export default class Quotations extends Vue {
    private currentUser!: any;
    private quotation_date = moment(new Date()).format('DD-MM-YYYY');
    private activeQuotation!: any;
    private activeQuotationLoading!: any;
    private searchQuery: string = '';
    private previewMode: boolean = false;
    public client!: any;
    public userSelected: any = '';
    public warehouseSelected: any = '';
    private preventNextIteration: any = false;
    private phoneValue: any = 0;
    private mlCategoriesList: Array<any> = [];
    private mlQuotation: boolean = false;
    private mlShipmentCost: number = 0;
    private mlCategorySelected: any = null;
    private mlListingType: boolean = false;
    private mlCategoryQuery: string = '';
    private totalProducts: number = 0;
    private productInQuotation: string = '';
    private isMobile = false;
    public reference = '';
    public productObservations = '';
    public currentAgent: any = '';
    public selectedAlmacen: any = 'all';

    almacenesOptions: any = [
        { value: 'all', text: 'Almacenes', disabled: true },
    ];

    get cost() {
        if (this.client.cliente) {
            this.activeQuotation.clientEmail = this.client.email1;
            this.activeQuotation.clientName = this.client.nombre;
            this.activeQuotation.clientPhone = this.client.telefonos;
        } else {
            this.activeQuotation.clientEmail = '';
            this.activeQuotation.clientName = '';
            this.activeQuotation.clientPhone = '';
        }
        let constante_z: number = 0;
        let subtotal_shipment: number = 0;
        let subtotal: number = this.activeQuotation.products.reduce((a: any, p: any) => a + p.price * p.qty, 0);
        let limite_envio: number = 0;
        if (this.mlQuotation && this.mlCategorySelected != null) {
            let category_comission: any = '';
            this.mlListingType
                ? (category_comission = this.mlCategorySelected.gold_pro)
                : (category_comission = this.mlCategorySelected.gold_special);
            constante_z = 1 / (1 - category_comission);
            limite_envio = 298.5 / constante_z - 25;
            this.mlShipmentCost = +this.mlShipmentCost;
            subtotal_shipment = subtotal;
            subtotal = subtotal * constante_z;
        }

        if (this.activeQuotation.globalDiscount > 0) {
            if (this.client.listapreciosesp == '(Precio 3)') {
                this.activeQuotation.globalDiscount = 0;
            }
            if (this.activeQuotation.globalDiscount > 6) {
                this.activeQuotation.globalDiscount = 6;
            }
            subtotal = subtotal - (subtotal * this.activeQuotation.globalDiscount) / 100;
        }

        let iva = subtotal * 0.16;
        if (this.mlShipmentCost > 0 && this.mlQuotation && this.mlCategorySelected != null) {
            subtotal = (subtotal_shipment + this.mlShipmentCost) * constante_z;
        }
        if (subtotal + iva <= limite_envio) {
            // subtotal = subtotal + 25;
            subtotal = subtotal;
        }
        return {
            subtotal,
            iva,
            total: subtotal + iva,
        };
    }

    onAddItem(parent: any) {
        parent.products.push({
            new: true,
        });
    }

    onSetItem(product: any, parent: any, index: number) {
        const productIndex = parent.products.findIndex((producto) => producto.id === product.id);
        const existingId = productIndex !== -1;

        if (existingId) {
            const qty = parent.products[productIndex].qty + 1;
            parent.products.splice(index, 1);
            parent.products[productIndex].qty = qty;
        } else {
            parent.products.splice(index, 1);
            parent.products.push({
                new: false,
                qty: 1,
                discount: 0,
                ...product,
            });
            this.totalProducts = parent.products.length;
        }
    }

    @Watch('searchQuery')
    @Debounce(600)
    updateProductsList(search: string) {
        if (/\s/.test(this.searchQuery)) {
            const finalSentence = this.searchQuery.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
            this.searchQuery = finalSentence;
        } else {
            this.searchQuery = this.searchQuery.toUpperCase();
        }

        if (this.searchQuery.length > 1 && this.searchQuery.trim() != '') {
            this.$store.dispatch('products/cacheAll', { search, limit: 40 });
        }
    }

    @Watch('searchQuery')
    @Debounce(600)
    updateClientsList(search: string) {
        search = search.toUpperCase();
        if (this.searchQuery.length > 1 && this.searchQuery.trim() != '') {
            this.$store.dispatch('products/cacheAllClients', { search, limit: 40 });
        }
    }

    // onRemoveItem(parent: any, index: any, product: any) {
    //     parent.products.splice(index, 1);
    // }

    getProductUrl(id: string) {
        return `https://www.prodelec.app/#/products?search=${id}&page=1`; // redirect to app.prodelec.mx
    }

    intelisisQuotation() {
        setTimeout(() => {
            if (this.activeQuotation.intelisis && !this.client.cliente) {
                this.client.cliente = 'V';
                this.client.listapreciosesp = '(Precio 2)';
                this.client.nombre = 'VENTA MOSTRADOR';
            }
        }, 100);
    }

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    createQuotation(){
        var date = moment(moment(), 'YYYY/MM/DD');
        let quoationId = date.format('YY') + date.format('MM') + date.format('DD');
        let items = [];
        this.activeQuotation.products.forEach((item: any) => {
            items.push({
                sku: item.id,
                price: +item.price,
                qty: +item.qty,
                subtotal: +item.price * +item.qty,
                discount: +item.discount
            });
        });

          let payload = {
                agent: this.currentAgent,
                client: this.client.cliente,
                global_discount: this.activeQuotation.globalDiscount,
                date: this.quotation_date,
                reference: this.reference,
                emailClient: this.activeQuotation.clientEmail,
                nameClient: this.activeQuotation.clientName,
                phoneClient: this.activeQuotation.clientPhone,
                notes: this.activeQuotation.notes,
                observations: this.productObservations,
                items: items,
                quoationId,
                almacen: this.selectedAlmacen
            };
    }

    onCreateQuotation() {
        if (!this.userSelected) {
            this.$bvToast.toast('Debes completar la información para continuar', {
                title: `Datos insuficientes`,
                variant: 'warning',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 5000,
            });
        } else {
            console.log('creating quoation in intelisis...');
            var date = moment(moment(), 'YYYY/MM/DD');
            let quoationId = date.format('YY') + date.format('MM') + date.format('DD');
            let items = [];
            this.activeQuotation.products.forEach((item: any) => {
                items.push({
                    sku: item.sku,
                    price: +item.price,
                    qty: +item.qty,
                    subtotal: +item.price * +item.qty,
                });
            });
            let payload = {
                user: this.userSelected,
                warehouse: this.warehouseSelected,
                client: this.client.cliente,
                precio: this.client.listapreciosesp,
                items: items,
                quoationId,
            };
            console.log(payload);

            this.$store.dispatch('products/postQuotation', { payload, vm: this });
            this.$store.dispatch('products/setQuotation', {
                clientName: '',
                clientEmail: '',
                clientPhone: '',
                products: [],
            });
            // this.$bvModal.hide('product-quotation-modal');
        }
    }

    setUrlSearchClient(client: any) {
        // @ts-ignore
        this.$store.dispatch('products/getClient', {
            client: client.cliente,
            vm: this,
        });
    }

    setUrlSearchUserIntelisis(user: any){
        this.currentAgent = user;

        const uniqueAlmacenes = Array.from(new Set(user.almacenes));

        this.almacenesOptions = [
            { value: 'all', text: 'Almacenes', disabled: true },
            ...uniqueAlmacenes
        ];

        this.activeQuotation = {
            ...this.activeQuotation, 
            agente: this.currentAgent.nombre, 
            departamento: this.currentAgent.departamento
        };
    }

    onSetAlmacen(almacen){
        this.activeQuotation = {
            ...this.activeQuotation,
            almacen: almacen
        };
    }

    clearFiltersClient() {
        this.searchQuery = '';
    }

    // private onAddQuotationItem() {
    //     this.activeQuotation.products.push({
    //         id: '',
    //         type: 'custom',
    //         title: '',
    //         price: 1,
    //         qty: 1,
    //         note: '',
    //     });
    // }

    generateDiscountProduct(product) {
        let priceP = 0;
        if (!product.original_price) {
            priceP = product.price;
        } else {
            priceP = product.original_price;
        }

        let newProduct = { ...product };

        if (newProduct.original_price === undefined) {
            newProduct.original_price = priceP;
        }

        if (product.discount !== '0') {
            const discount = (product.price * product.discount) / 100;
            const price_discount = priceP - discount;

            newProduct = { ...newProduct, price_discount: price_discount };
            product.original_price = newProduct.original_price;
            product.price = newProduct.price_discount;
        } else {
            if (!product.original_price) {
                product.price;
            } else {
                product.price = product.original_price;
            }
        }
    }

    private onRemoveQuotationItem(index: number) {
        this.activeQuotation.products.splice(index, 1);
        this.totalProducts = this.activeQuotation.products.length;
        console.log(this.totalProducts);
    }

    private ensurePositiveNumber($event: any) {
        console.log('event', $event);

        $event = $event ? $event : window.event;
        var charCode = $event.which ? $event.which : $event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
            $event.preventDefault();
        } else {
            return true;
        }
    }

    onCreateOrder() {
        //create order
        let clearQuotation = {
            clientName: '',
            clientEmail: '',
            clientPhone: '',
            products: [],
        };
        this.$store.dispatch('products/postOneOrder', {
            vm: this,
            newOrder: this.activeQuotation,
            user: this.currentUser,
        });
        this.$store.dispatch('products/setQuotation', clearQuotation);
        // this.$bvModal.hide('product-quotation-modal');
    }

    phoneNumberValidation(event) {
        // console.log(event);
        if (['Arrow', 'Backspace', 'Shift'].includes(event.key)) {
            this.preventNextIteration = true;
            return;
        }
        if (this.preventNextIteration) {
            this.preventNextIteration = false;
            return;
        }
        this.phoneValue = this.activeQuotation.clientPhone.replace(/-/g, '').match(/(\d{1,10})/g)[0];
        this.activeQuotation.clientPhone = this.phoneValue.replace(/(\d{1,3})(\d{1,3})(\d{1,4})/g, '$1-$2-$3');
    }

    private clearCategory() {
        this.mlCategorySelected = null;
    }

    clearFilters() {
        this.client = {
            cliente: null,
            listapreciosesp: null,
        };
        this.searchQuery = '';
        this.activeQuotation.intelisis = false;
    }

    private setMlCategory($event: any) {
        console.log($event);
        this.mlCategorySelected = $event;
    }

    private onPrint() {
        if (this.activeQuotation.products.length <= 0) {
            alert('Aún no hay artículos en la lista');
            return false;
        }

        // console.log('Current user => ', this.currentUser);
        // console.log('Current products => ', this.activeQuotation.products);
        // @ts-ignore
        const html = this.onGenerateHtml(true);

        // Open the print window
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

        // @ts-ignore
        WinPrint.document.write(html);
        // @ts-ignore
        WinPrint.document.close();
        // @ts-ignore
        WinPrint.focus();
        // @ts-ignore
        setTimeout(() => {
            WinPrint.print();
        }, 500);
    }

    private onGenerateHtml(isPDF = false) {
        // si son 8 partidas 1 pagina
        // si son más de 8, renderea 9 en la primera pagina sin bloque de total
        const max_items_per_page = isPDF ? 8 : 9999;
        const expiration = 5;
        const page_height = 964;
        const black = '#1a1a1a';
        const gray = '#b3b3b3';
        const blue = '#0000ff';

        let htmlBuild = '';
        let style = '';
        let big_logo = 'https://directus.prodelec.app/assets/a02991de-09d5-4913-b7d4-981d8ab809ec';
        let small_logo = 'https://directus.prodelec.app/assets/5f3c9661-2efe-449c-aec4-0290c73da4ea';

        style += `@import url('https://fonts.googleapis.com/css?family=Montserrat:300,500,700,800&display=swap');`;
        style += `html { font-family: 'Montserrat'; }`;
        style += `p { margin: 0; }`;
        style += `body { font-size: 11px; color: ${black}; }`;
        style += `table { width: 100%; border-collapse: collapse; }`;
        style += `.page { display: flex; flex-direction: column; height: ${page_height}px; justify-content: space-between; }`;

        // header

        style += `#page-header tr { height: 20px; }`;
        style += `#page-header th { text-align: left; width: 4%; font-weight: bold; }`;
        style += `#page-header td { text-align: left; width: 15% }`;

        //data

        style += `#page-data tr:not(:first-of-type) { height: 76.8px; }`;
        style += `#page-data tr th:nth-last-child(5) { width: 10% }`; //CANTIDAD
        style += `#page-data tr th:nth-last-child(4) { }`; //CLAVE
        style += `#page-data tr th:nth-last-child(3) { }`; //DESCRIPCIÓN
        style += `#page-data tr th:nth-last-child(2) { width: 20% }`; //PRECIO UNITARIO
        style += `#page-data tr th:nth-last-child(1) { width: 15% }`; //IMPORTE
        style += `#page-data tr td:nth-last-child(2) { text-align: right; }`;
        style += `#page-data tr td:nth-last-child(1) { text-align: right; }`;
        style += `#page-data th { padding-top: 10px; padding-bottom: 10px; text-align: left; font-weight: bold; font-size: 10px; text-transform: uppercase; border-bottom: 1px solid ${gray}; color: ${gray}; }`;
        style += `#page-data td { padding-top: 10px; padding-bottom: 10px; vertical-align: top; border-bottom: 1px solid ${gray}; }`;

        //total

        style += `#page-total tr { height: 20px; }`;
        style += `#page-total td { vertical-align: top; }`;
        style += `#page-total tr td:nth-last-child(2) { width: 15%; text-align: right; }`;
        style += `#page-total tr td:nth-last-child(1) { width: 15%; text-align: right; }`;
        style += `#page-total tr:last-of-type td:nth-last-child(2) { border-top: 1px solid ${gray}; }`;
        style += `#page-total tr:last-of-type td:nth-last-child(1) { border-top: 1px solid ${gray}; }`;
        style += `#page-total tr:nth-of-type(1) td { padding-top: 10px; }`;
        style += `#page-total tr:nth-of-type(2) td { padding-top: 10px; padding-bottom: 10px; }`;
        style += `#page-total tr:nth-last-of-type(1) td { padding-top: 10px; }`;

        //footer

        style += `#page-footer tr { height: 20px; }`;
        style += `#page-footer tr th:nth-child(1) { width: 25%; text-align: left; }`;
        style += `#page-footer tr th:nth-child(2) { width: 25%; text-align: left; }`;
        style += `#page-footer tr td:nth-child(3) { text-align: right; }`;
        style += `#page-footer th { color: ${blue}; font-weight: normal; }`;

        // PAGE START

        htmlBuild += `<!DOCTYPE html>`;
        htmlBuild += `<html>`;
        htmlBuild += `<head>`;
        htmlBuild += `<style>${style}</style>`;
        htmlBuild += `<title>Cotización</title>`;
        htmlBuild += `</head>`;
        htmlBuild += `<body>`;

        let pages: any = [];

        _.chunk(this.activeQuotation.products, max_items_per_page).forEach((products, index) => {
            pages.push({
                index: index + 1,
                products,
                has_total: false,
            });
        });

        pages[pages.length - 1] = {
            ...pages[pages.length - 1],
            has_total: true,
        };

        // PAGE

        pages.forEach((page: any) => {
            htmlBuild += `<div class="page">`;
            htmlBuild += `<div class="upper">`;

            // PAGE HEADER

            htmlBuild += `<table id="page-header">`;

            htmlBuild += `<tr>`;
            htmlBuild += `<td style="text-align:left;vertical-align:top;" rowspan="6"><img src="${big_logo}" width="160px"></td>`;
            htmlBuild += `<th>Cotización</th><td>N/A</td>`;
            if (this.activeQuotation.globalDiscount > 0) {
                htmlBuild += `<th>Descuento</th><td>%${this.activeQuotation.globalDiscount}</td>`;
            }
            htmlBuild += `</tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>Elaboración</th><td>${moment().format('DD/MM/YYYY')}</td>`;
            htmlBuild += `<th>Vigencia</th><td>${expiration} días hábiles</td>`;
            htmlBuild += `</tr><tr></tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>Atención a</th><td>${this.activeQuotation.clientName || 'Quien Corresponda'}</td>`;
            htmlBuild += `<th>Vendedor</th><td>${this.currentUser.first_name} ${this.currentUser.last_name}</td>`;
            htmlBuild += `</tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>E-mail</th><td>${this.activeQuotation.clientEmail}</td>`;
            htmlBuild += `<th>E-mail</th><td>${this.currentUser.email}</td>`;
            htmlBuild += `</tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>Teléfono</th><td>${this.activeQuotation.clientPhone}</td>`;
            // htmlBuild += `<th>Teléfono</th><td>${this.currentUser.phone}</td>`;
            htmlBuild += `<th>Teléfono</th><td></td>`;
            htmlBuild += `</tr>`;

            // htmlBuild += `<tr>`;
            // // htmlBuild += `<th></th><td></td>`;
            // htmlBuild += `<th>Descuento</th><td>%${this.activeQuotation.globalDiscount}</td>`;
            // htmlBuild += `</tr>`;

            htmlBuild += `<tr></tr><tr></tr>`;

            htmlBuild += `</table>`;

            // DATA

            htmlBuild += `<table id="page-data">`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th >Cantidad</th>`;
            htmlBuild += `<th>Clave</th>`;
            htmlBuild += `<th>Descripción</th>`;
            htmlBuild += `<th>Precio Unitario</th>`;
            htmlBuild += `<th>Importe</th>`;
            htmlBuild += `</tr>`;

            page.products.forEach((product: any) => {
                htmlBuild += `<tr>`;
                htmlBuild += `<td>${product.qty}</td>`;
                htmlBuild += `<td>${product.id || ''}</td>`;
                htmlBuild += `<td>`;
                htmlBuild += `<p>${product.name}</p>`;
                // htmlBuild += `<p><small>${product.note}</small></p>`;
                htmlBuild += `</td>`;
                htmlBuild += `<td style="text-align: center;">${this.$options.filters.currency(product.price)}</td>`;
                htmlBuild += `<td style="text-align: center;">${this.$options.filters.currency((product.qty * product.price).toFixed(2))}</td>`;
                htmlBuild += `</tr>`;
            });

            htmlBuild += '</table>';

            // PAGE TOTAL

            if (page.has_total) {
                htmlBuild += '<table id="page-total">';

                htmlBuild += `<tr>`;
                htmlBuild += `<td rowspan="3">NOTA: <i> Los montos están en moneda nacional MXN. Oferta sujeta a la disponibilidad de productos y cambio de precios sin previo aviso. </i> <br> ${this.activeQuotation.note}</td>`;
                htmlBuild += `<td>SUBTOTAL</td>`;
                // @ts-ignore
                htmlBuild += `<td>${this.$options.filters.currency(this.cost.subtotal)}</td>`;
                htmlBuild += `</tr>`;

                htmlBuild += `<tr>`;
                htmlBuild += `<td>IVA</td>`;
                // @ts-ignore
                htmlBuild += `<td>${this.$options.filters.currency(this.cost.iva)}</td>`;
                htmlBuild += `</tr>`;

                htmlBuild += `<tr>`;
                htmlBuild += `<td>TOTAL</td>`;
                // @ts-ignore
                htmlBuild += `<td>${this.$options.filters.currency(this.cost.total)}</td>`;
                htmlBuild += `</tr>`;

                htmlBuild += `</table>`;
            }

            htmlBuild += `</div>`;
            htmlBuild += `<div class="lower">`;

            // PAGE FOOTER

            htmlBuild += `<table id="page-footer">`;

            htmlBuild += `<tr></tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th><p style="font-size:15px;font-weight:semi-bold;"><img width="12px" src="${small_logo}"> www.prodelec.mx</p></th>`;
            htmlBuild += `<th>info@prodelec.mx</th>`;
            htmlBuild += `</tr>`;

            htmlBuild += `<tr>`;
            htmlBuild += `<th>Morelia, Michoacán, México</th>`;
            htmlBuild += `<th>(443) 316 2300</th>`;
            htmlBuild += `<td rowspan="2">Página ${page.index} de ${pages.length}</td>`;
            htmlBuild += `</tr>`;

            htmlBuild += `</table>`;

            htmlBuild += `</div>`;
            htmlBuild += `</div>`;
        });

        // PAGE END

        htmlBuild += `</body>`;
        htmlBuild += `</html>`;

        return htmlBuild;
    }

    private async onGenerateExcel() {
        let html = this.activeQuotation.products.reduce((acc: any, val: any) => {
            return val.id ? acc + `<tr><td>${val.id}</td><td>${val.qty}</td></tr>` : '';
        }, '');

        const wb: XLSX.WorkBook = XLSX.read(`<table>${html}</table>`, {
            type: 'string',
        });
        XLSX.writeFile(wb, `${moment().format('YYMMDDHHmmss')}.xls`);
    }

    mounted() {
        this.$store.dispatch('products/getUsersIntelisis');
        // mover a state
        console.log(this.currentUser.role.name);
        if (
            this.currentUser.role.name == 'MercadoLibre Manager' ||
            this.currentUser.role.name == 'Admin' ||
            this.currentUser.role.name == 'Developer'
        ) {
            directusApi('GET', `items/mercadolibre_categories`)
                .then((response: any) => {
                    this.mlCategoriesList = response.data.data;
                })
                .catch((e) => console.log(e));
        }
        this.handleResize();
         window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
      this.isMobile = window.innerWidth <= 768;
    }
}
